/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeadReplacementsResponseApiModel } from '../../models/lead-replacements-response-api-model';

export interface GetReplacements$Params {
}

export function getReplacements(http: HttpClient, rootUrl: string, params?: GetReplacements$Params, context?: HttpContext): Observable<StrictHttpResponse<LeadReplacementsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getReplacements.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeadReplacementsResponseApiModel>;
    })
  );
}

getReplacements.PATH = '/admin/replacements';
